import React, { useEffect } from "react";
import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./AboutMe.css";

import Profile from "../../assets/AboutMe/About-Florence.jpg";

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTANTS = {
    description:
      "Self-motivated, Innovative and Enthusiastic DevOps Engineer and Pharmacist. Passionate for pharmacy-related technologies. I am always searching for the latest tools and methodologies. Being able to work confidently by myself has allowed me to become proficient in a wide variety of technologies whilst my strong interpersonal skills have enabled me to excel in teams also.",
    highlights: {
      bullets: [
        "Automation in CI/CD (Jenkins, Terraform)",
        "Cloud Services Provisioning using AWS",
        "Infrastructure Management (Terraform and Ansible)",
        "Containerized Deployment using Docker and Kubernetes",
        "Monitoring and Logging (Prometheus and Grafana)",
        "Collaboration and Communication",
        "Pharmaceutical Knowledge and Medication Management"
      ],
      heading: "Here are some fields of my expertise:",
    },
  };

  const renderHighlight = () => {
    return SCREEN_CONSTANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading
          title={"About Me"}
          subHeading={"Why Choose Me For the Job or Project?"}
        />
        <div className="about-me-card-main">
          <div className="about-me-card">
            <div className="about-me-profile">
              <img src={Profile} alt="Not responding"></img>
            </div>
            <div className="about-me-details">
              <span className="about-me-description">
                {SCREEN_CONSTANTS.description}
              </span>
              <div className="about-me-highlights">
                <div className="highlight-heading">
                  <span>{SCREEN_CONSTANTS.highlights.heading}</span>
                </div>
                {renderHighlight()}
              </div>
              <div className="about-me-options">
                <div>
                <button
                  className="btn primary-btn"
                  onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
                >
                  {" "}
                  Contact Me{" "}
                </button>
                </div>
                <div>
                <a href="FlorenceDevOpsCV.pdf" download="Florence Omoruyi CV/Résumé.pdf">
                  <button className="btn highlighted-btn">Get CV/Résumé</button>
                </a>
                </div>
              </div>
            </div>
          </div>
          <div className="useless"></div>
        </div>
      </div>
    </div>
  );
}
